export default __webpack_public_path__ + "static/media/portfolio-63.f6d649af.jpg";